<template>
  <div>
    <div class="row mt-2 controls-wrap">
      <div class="col-8">
        <TitleBreadcrumb :page="page" />
      </div>

      <div class="col-4 row justify-content-end">
        <div class="h-16">
          <div class="col-12 d-flex mt-3 justify-content-end">
            <div class="d-flex">
              <button
                id="btnFA"
                class="btn btn-action btn-green pt-1"
                @click="goBack"
              >
                <em class="fas fa-arrow-circle-left pr-1" />
                Regresar
              </button>
            </div>

            <div class="d-flex">
              <button
                v-if="!atCompletedFlag"
                id="btnFA"
                class="btn btn-action btn-green pt-1"
                :disabled="isSaveBtnDisabled"
                @click="saveCurrentTab()"
              >
                <em class="fas fa-save pr-2" />
                Guardar
              </button>
            </div>
            <div v-if="showActions" class="d-flex">
              <div class="dropdown drop">
                <button
                  id="dropdownMenuButton"
                  class="btn btn-dropdown-actions dropdown-toggle float-right pt-1 action-button"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Acciones
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton"
                >
                  <div
                    v-if="showNotCompleted"
                    class="dropdown-item"
                    @click="notComplete"
                  >
                    <em class="fa fa-flag fa-edit text-green pr-1" />
                    <span>No Completar</span>
                  </div>

                  <div
                    v-if="showcompleted"
                    class="dropdown-item"
                    @click="complete"
                  >
                    <em class="fa fa-flag fa-edit text-green pr-1" />
                    <span>Completar</span>
                  </div>

                  <div
                    v-if="!atCompletedFlag"
                    class="dropdown-item"
                    @click="callChild = !callChild"
                  >
                    <em class="fa fa-editfas fa-edit text-green pr-1" />
                    <span>Cambiar Pregunta de Evaluación</span>
                  </div>
                  <a class="dropdown-item" href="#" />
                </div>
              </div>
              <PreEvaluationAnswer :call-back="callChild" :is-new="false" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="dropdown-divider mt-2 pb-2 w-100" />   
      <Tabs :key="reRenderTabs" ref="currentTab" />  
      <footer-buttons :range="230">
        <div slot="buttons">
          <ActionButton
            v-show="!atCompletedFlag"
            variant="success"
            i="fas fa-save"
            type="submit"
            :disabled="isSaveBtnDisabled"
            @click="saveCurrentTab"
          >
            Guardar
          </ActionButton>
        </div>
      </footer-buttons>
    </div>
  </div>
</template>
<script>
import TitleBreadcrumb from '@/components/common/page/TitleBreadcrumb';
import PreEvaluationAnswer from '@/components/at/popup/PreEvaluationAnswer';
import Tabs from '@/components/at/Tabs';
import atService from '../services/pei/at';
import resourcesService from '../services/resources.js';
import store from '@/store/index';
import alert from '@/mixin/alert.mixin';
import loading from '@/mixin/loading.mixin';
import FooterButtons from '@/components/common/FooterButtons';
import ActionButton from '@/components/common/ActionButton';
export default {
  mixins: [loading, alert],
  components: {
    TitleBreadcrumb: TitleBreadcrumb,
    Tabs: Tabs,
    PreEvaluationAnswer: PreEvaluationAnswer,
    FooterButtons,
    ActionButton,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-desktop',
        title: 'Referido para Servicios de Asistencia Tecnológica',
        routes: [
          'Inicio',
          'PEI',
          'Referido para Servicios de Asistencia Tecnológica',
        ],
      },
      callChild: false,
      reRenderTabs: 0,
      headerAt: {},
      showFooterBar: false,
      showNotCompleted: false,
      showcompleted: false,
      showActions: false,
      peiId: store.getters.SelectedPei,
      questionNotCompleted: '',
      selectedPeiStatus: store.getters.SelectedPeiStatus,
    };
  },
  methods: {
    handleScroll() {
      let currentScrollPos = window.pageYOffset;
      this.showFooterBar = 230 <= currentScrollPos;
      this.prevScrollpos = currentScrollPos;
    },
    saveCurrentTab: async function() {       
      this.$refs.currentTab.save();      
    },
    async complete() {        
       atService.completeAtService(store.getters.SelectedAt).then((response) => {
        this.setPeiAtInformation = response.data;
        if (response.data !== undefined && response.data !== null) {
          let tabValidations = {
            validation: response.data.filter((v) => v.value == true).length > 0,
            validTabs: response.data,
          };
          store.dispatch('setAtValidationTriggered', tabValidations);
          this.getHeaderAt();
          this.reRenderTabs += 1;
        }
      });
    },
    async getHeaderAt() {
      let self = this;
      if (this.peiAtServiceId != undefined && this.peiId != undefined) {
        this.$ApiGet(
          'api/atservice/getheaderat?peiAtServiceId=' +
            this.peiAtServiceId +
            '&peiid=' +
            this.peiId
        ).then((res) => {
          self.headerAt = res.data;
          if (self.headerAt) {
            self.showNotCompleted =
              self.headerAt.peiIsDraft && self.headerAt.atServiceIsCompleted;

            self.showcompleted =
              self.headerAt.peiIsDraft && !self.headerAt.atServiceIsCompleted;

           self.showActions = !self.headerAt.isReferralGenerated;

            store.dispatch(
              'setAtCompleted',
              self.headerAt.atServiceIsCompleted
            );
          } else {
            store.dispatch('setAtCompleted', false);
          }
        });
      }
    },
    async notComplete() {
      let answer = await alert.methods.ShowCancelModal(
        'Atención ',
        this.questionNotComplete,
        'Si',
        'No'
      );
      if (answer) {
        atService.notCompleteAtService(store.getters.SelectedAt).then(() => {
          this.getHeaderAt();
          this.reRenderTabs += 1;
          store.dispatch('setAtCompleted', this.headerAt.atServiceIsCompleted);
        });
      }
    },
    async getQuestionNotComplete() {
      let resources = await resourcesService.LoadValidationMessages([
        'R03200002',
      ]);

      if (resources['R03200002'] != undefined) {
        this.questionNotComplete = resources['R03200002'];
      }
    },
    goBack() {
      const self = this;
      self.$root.$router.push('/pei/detail?tab=Tab7');
    },
  },
  async mounted() {
    await this.getHeaderAt();
    await this.getQuestionNotComplete();
  },
  computed: {
    atCompletedFlag() {
      return store.getters.getAtCompleted;
    },
    peiAtServiceId() {
      return store.getters.SelectedAt;
    },
    isSaveBtnDisabled() {
      return store.getters.atSaveBtnDisabled;
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
<style scoped>
.footer-success {
  margin: 8px !important;
}

.dropdown-item:hover {
  background-color: #f7f7f7;
  cursor: grab;
  box-shadow: 0px 5px 5px #ededed;
}

.action-button {
  min-height: 38px;
  min-width: 119px;
  border: 1px solid #2db782;
}
</style>
